function SiteDashboard() {
  return (
    <main>
      <h1>Site Administration</h1>
    </main>
  );
}

export default SiteDashboard;
